import { jwtDecode } from 'jwt-decode';
import { BACKEND_URL } from "../url/Url";

const ADMIN = `${BACKEND_URL}/api/token/custom/`;
const UPDATE_USER = `${BACKEND_URL}/modif-personnel/`;

const AuthService = {
  connection: async (username, password) => {
    try {
      const response = await fetch(ADMIN, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();
        const decodedToken = jwtDecode(data.access);
        const userId = decodedToken.user_id;

        localStorage.setItem('accessToken', data.access);
        localStorage.setItem('refreshToken', data.refresh);
        localStorage.setItem('userId', userId);

        return { success: true };
      } else if (response.status === 401) {
        return { success: false, error: 'Invalid credentials' };
      } else {
        const errorData = await response.json();
        alert(errorData.error);
        return { success: false, error: errorData };
      }
    } catch (error) {
      console.error('Error during login:', error);
      return { success: false, error: error.message };
    }
  },

  updateAccount: async (userId, nom, motDePasse, poste) => {
    try {
      const response = await fetch(`${UPDATE_USER}${userId}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: nom, password: motDePasse, code: poste }),
      });

      if (response.ok) {
        return { success: true };
      } else {
        const errorData = await response.json();
        alert(errorData.error);
        return { success: false, error: errorData };
      }
    } catch (error) {
      console.error('Error during update:', error);
      return { success: false, error: error.message };
    }
  },

  deconnection: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userId');
  },

  getCode: () => {
    const token = localStorage.getItem('accessToken');
    if (!token) return null;
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.code;
    } catch (error) {
      console.error('Invalid token:', error);
      return null;
    }
  },

  estConnecte: () => {
    const token = localStorage.getItem('accessToken');
    if (!token) return false;

    try {
      const decodedToken = jwtDecode(token);
      const expiration = decodedToken.exp * 1000;
      if (Date.now() >= expiration) {
        AuthService.deconnection();
        return false;
      }
      return true;
    } catch (error) {
      console.error('Invalid token:', error);
      AuthService.deconnection();
      return false;
    }
  },

  hasRoles: (requiredRoles) => {
    const token = localStorage.getItem('accessToken');
    if (!token) return false;
    try {
      const decodedToken = jwtDecode(token);
      const userRoles = decodedToken.roles || [];
      return requiredRoles.every(role => userRoles.includes(role));
    } catch (error) {
      console.error('Invalid token:', error);
      return false;
    }
  },
};

export default AuthService;
